import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import './CTA.css';

export default function CTASection() {
  const { t } = useLanguage();

  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-inner">
          <h2>{t.cta.title}</h2>
          <p>{t.cta.subtitle}</p>
          <Link to="/order" className="btn btn-primary">
            {t.cta.button}
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
